import React, { FC } from 'react';
import { SalesTrendLine } from 'entities/MonitorSales/components/SalesTrendLine';
import { ChangeArrow } from 'entities/MonitorSales/components/ChangeArrow';

interface IComponentProps {
  data?: number[];
}

export const SummaryTrendRow: FC<IComponentProps> = ({ data = [] }) => {
  const trendUp = data.length >= 2 && data[data.length - 1] >= data[data.length - 2];

  return (
    <div className="mb-4 ms-summary__sparkline">
      <SalesTrendLine data={data} />
      <ChangeArrow up={trendUp} />
    </div>
  );
};
